import { render, staticRenderFns } from "./AddBroadcast.vue?vue&type=template&id=658f2183&scoped=true&"
import script from "./AddBroadcast.vue?vue&type=script&lang=js&"
export * from "./AddBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./AddBroadcast.vue?vue&type=style&index=0&id=658f2183&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f2183",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VRadio,VRadioGroup,VSelect,VTextField})
